import { Link, useLocation } from 'react-router-dom'
import { Outlet } from 'react-router'
import { Compass, PenTool, Book, Settings } from 'lucide-react'
import Footer from '@/components/Footer'

const MainLayout = () => {
  const location = useLocation()
  
  // 判断链接是否激活
  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/'
    }
    return location.pathname.startsWith(path)
  }

  // 导航项配置
  const navItems = [
    { path: '/discover', icon: Compass, label: '发现' },
    { path: '/create', icon: PenTool, label: '创作' },
    { path: '/my-works', icon: Book, label: '作品' },
    { path: '/settings', icon: Settings, label: '设置' }
  ]

  return (
    <div className="min-h-screen flex flex-col">
      {/* 顶部导航栏 */}
      <header className="sticky top-0 z-50 nav-header">
        <div className="max-w-7xl mx-auto px-6 w-full">
          <div className="flex items-center justify-between h-16">
            {/* Logo 区域 */}
            <Link to="/" className="flex items-center gap-3 group">
              <img 
                src="/logo.png"
                alt="艾小喵绘本馆" 
                className="w-12 h-12 object-contain transition-all duration-300 group-hover:scale-110 filter blur-[0.2px] drop-shadow-[0_0_2px_rgba(0,0,0,0.1)]"
              />
              <span className="text-2xl md:text-3xl font-bold bg-clip-text text-transparent bg-gradient-to-r from-primary via-accent to-secondary animate-rainbow-text">
                艾小喵绘本馆
              </span>
            </Link>

            {/* 导航链接 */}
            <nav className="flex items-center space-x-4">
              {navItems.map(({ path, icon: Icon, label }) => (
                <Link
                  key={path}
                  to={path}
                  className={`nav-item ${isActive(path) ? 'active' : ''}`}
                >
                  <div className="flex items-center gap-2">
                    <Icon className={`nav-icon ${isActive(path) ? 'text-primary' : ''}`} />
                    <span>{label}</span>
                  </div>
                </Link>
              ))}
            </nav>
          </div>
        </div>
      </header>

      {/* 主内容区 */}
      <main className="max-w-7xl mx-auto px-6 py-8 flex-1 w-full">
        <Outlet />
      </main>

      {/* 添加页脚 */}
      <Footer />
    </div>
  )
}

export default MainLayout 